
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seguros",
      function () {
        return require("private-next-pages/seguros/index.js");
      }
    ]);
  